/* Keep all copy in its detail panel, regardless of the editor's paragraph structure. */
(() => {
  if (customElements.get('andcharlie-product-description')) return;
  const text = (node) => node.textContent.replace(/[\s\u00a0\u200b-\u200d\ufeff]+/gu, '').trim();
  const media = 'img,picture,video,audio,svg,iframe,object,embed,table,hr,input,select,textarea,button';

  class AndCharlieProductDescription extends HTMLElement {
    connectedCallback() {
      this.initializeBound ||= () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.initializeBound, { once: true });
      else this.initialize();
    }

    disconnectedCallback() { document.removeEventListener('DOMContentLoaded', this.initializeBound); }

    initialize() {
      if (this.initialized || !this.isConnected) return;
      const source = this.querySelector('[data-ac-content-source]');
      if (!source) return;
      this.initialized = true;
      this.dataset.acDescriptionState = 'whole';

      // Old copy can start with a styled "商品説明" label. Hide only an exact
      // duplicate of our heading; retain its DOM, every paragraph, link and image.
      const heading = this.querySelector('[data-ac-about-title]');
      let first = source;
      while (first) {
        first = Array.from(first.childNodes).find(node => node.nodeType === 1 || (node.nodeType === 3 && text(node)));
        if (!first || first.nodeType !== 1 || !first.matches('div,p,span,strong,b,h1,h2,h3,h4,h5,h6')) break;
        if (first.matches('[id],[role],[aria-label],[aria-labelledby],[aria-describedby],[itemscope]')) break;
        if (heading && text(first) === text(heading) && !first.querySelector(`${media},a,[id],[role]`)) {
          first.hidden = true;
          first.dataset.acDuplicateHeading = '';
          // BRs immediately following an inline label are its separators.
          let next = first.nextSibling;
          while (next && ((next.nodeType === 3 && !text(next)) || next.nodeName === 'BR')) {
            if (next.nodeName === 'BR') next.hidden = true;
            next = next.nextSibling;
          }
          break;
        }
      }
      const visibleText = [...source.querySelectorAll('*'), source].some(node =>
        !node.closest('[hidden], [aria-hidden="true"]') && Array.from(node.childNodes).some(child => child.nodeType === 3 && text(child))
      );
      const hasMedia = Array.from(source.querySelectorAll(media)).some(node => !node.closest('[hidden], [aria-hidden="true"]'));
      const about = source.closest('[data-ac-content-section="about"]');
      if (about) about.hidden = !visibleText && !hasMedia;
    }
  }
  customElements.define('andcharlie-product-description', AndCharlieProductDescription);
})();
